<template>
  <embed style="width: 100%; height: calc(100vh - 200px)" :src="'/enveditor'">
</template>
<style lang="scss" scoped>
</style>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'EnvEditor',
  components: {
  },
  computed: {},
  methods: {
  },
  mounted() {
  }
};
</script>
